import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import Banner from '../../components/banner'
import Gallery from '../../components/gallery'
import Head from '../../components/head'
import Layout from '../../components/layouts/mainLayout'

const Gallery2K20 = () => {

    const data = useStaticQuery(graphql`
        query {
            gallery: allFile (filter: {sourceInstanceName: {eq: "gallery-2020"}} 
            ){
                edges {
                    node {
                        ...FluidImageFragment
                    }
                }
            }
        }
    `)

    return (

        <Layout>
            <Head title="2020 Gallery" />
            <Gallery data={data.gallery.edges} />
        </Layout>
        
    )
}

export default Gallery2K20